export const IMPORT_SITE_DATE_REQUEST = 'IMPORT_SITE_DATE_REQUEST';
export const IMPORT_SITE_DATE_SUCCESS = 'IMPORT_SITE_DATE_SUCCESS';
export const IMPORT_SITE_DATE_ERROR = 'IMPORT_SITE_DATE_ERROR';

export const importSiteDate = (formData) => {
    return {
        type: 'CALL_API',
        types: [IMPORT_SITE_DATE_REQUEST, IMPORT_SITE_DATE_SUCCESS, IMPORT_SITE_DATE_ERROR],
        path: `api/site/import`,
        method: 'post',
        payload: {
            formData
        },
    };
}


// WEBPACK FOOTER //
// ./src/modules/vegetation/actions/site.js